// eslint-disable-next-line no-restricted-imports
import { Select as MuiSelect } from '@mui/material';
import { forwardRef } from 'react';
import { SelectProps } from './mui-index';

export const Select = forwardRef(({ classes, ...props }: SelectProps<string>, ref) => (
  <MuiSelect {...props} classes={{ ...(classes ?? {}), nativeInput: 'data-hj-allow' }} ref={ref} />
));
